var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMana11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-130.58 306.79)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6 0 0 6 5170.6 323.23)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -790,
    cy: -55.002,
    r: 50,
    fill: "#cac5c0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m369.56-196.85v305.04c0 36.294 15.095 54.42 45.216 54.42h7.6739v20.694h-162.49v-20.694h10.728c30.654 0 46.002-18.126 46.002-54.42v-200.04c0-36.798-13.038-55.17-39.108-55.17h-16.098v-20.694h6.1444c31.68 0 60.282-9.702 85.824-29.13l16.104-7e-3zm194.69 0v305.04c0 36.294 15.066 54.42 45.222 54.42h7.6682v20.694h-162.52v-20.694h10.728c30.69 0 46.002-18.126 46.002-54.42v-200.04c0-36.798-13.038-55.17-39.078-55.17h-16.092v-20.694h6.1142c31.679 0 60.282-9.702 85.86-29.13l16.092-7e-3z",
    fill: "#0d0f0f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMana11);
export default __webpack_public_path__ + "static/media/mana11.7a7eaea7bc41a5217bc97b9c5671b38b.svg";
export { ForwardRef as ReactComponent };